import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Button = {
    label: string;
    active: boolean;
    onCheck: (value: string | number) => void;
    value: string | number;
}

const RadioButton = ({ label, active, onCheck, value }: Button) => (
    <div className={"radio-button " + (active ? 'radio-button-active' : '')} onClick={() => onCheck(value)}>
        <div className="radio-button-circle">
            {active ? <FontAwesomeIcon icon={["fas", "check"]} /> : null}
        </div>
        <label>{label}</label>
    </div>
)

export default RadioButton;